import { InputModel } from "../../utils/types"

export const resendReportForm = {
  user_assign: {
    label: `reportFolio.modal.sendReport.userWhoResponded`,
    name: 'user_assign',
    value: false,
    type: 'check',
    translate: true,
  },
  users_supervisors: {
    label: `reportFolio.modal.sendReport.userSupervisor`,
    name: 'users_supervisors',
    value: false,
    type: 'check',
    translate: true,
  },
  users_store: {
    label: `reportFolio.modal.sendReport.userStore`,
    name: 'users_store',
    value: false,
    type: 'check',
    translate: true,
  },
  user_manage_store: {
    label: `reportFolio.modal.sendReport.agentStore`,
    name: 'user_manage_store',
    value: false,
    type: 'check',
    translate: true,
  },
  email_store: {
    label: `reportFolio.modal.sendReport.emailStore`,
    name: 'email_store',
    value: false,
    type: 'check',
    translate: true,
  },
} as { [x: string]: InputModel }

export const resendReportFormUser = {
  users_direct_parents: {
    label: `reportFolio.modal.sendReport.usersDirectParents`,
    name: 'users_direct_parents',
    value: false,
    type: 'check',
    translate: true,
  },
  user_creator: {
    label: `reportFolio.modal.sendReport.userCreator`,
    name: 'user_creator',
    value: false,
    type: 'check',
    translate: true,
  },
  user_assign: {
    label: `reportFolio.modal.sendReport.userAssign`,
    name: 'user_assign',
    value: false,
    type: 'check',
    translate: true,
  },
} as { [x: string]: InputModel }

export const resendReportFormEmails = {
  externalEmails: {
    label: `reportFolio.modal.sendReport.email`,
    name: 'externalEmails',
    value: '',
    rest: {
      multiline: true,
      rows: 5,
      placeholder: "ejemplo@email.com, test@email.com"
    },
    translate: true,
  },
}